module.exports = __webpack_public_path__ + "static/media/clock.61954053.png";